import { checkEnviromentIsB2B } from 'src/utils/checkEnviroment'
import { useMobile } from 'src/hooks/useMobile'
import { Statsig } from 'src/sdk/statsig'
import { SHELF_EXPERIMENT_ID } from 'src/components/common/StatsigExposure/StatsigExposure'

import BlueProductFlag from '../../common/BlueProductFlag/BlueProductFlag'

type Props = {
  flag: {
    value: string
    color: string
    textColor: string
    icon: string | null
  }
  className: string
}

function ProductFlag({ flag, className }: Props) {
  const isB2B = checkEnviromentIsB2B()
  const clubFlag = flag?.value === 'Oferta Clube Decathlon'
  const { isMobile } = useMobile()

  const isExperimentalVitrine =
    Statsig.useStatsigFeatureGateValue(SHELF_EXPERIMENT_ID)

  if (isB2B && flag?.value === 'Oferta Clube Decathlon') {
    return null
  }

  const isBalckFriday = flag?.value.toLowerCase() === 'black friday'

  const isBlueProduct = flag?.value === 'Produto Azul'

  const flagSize = isMobile
    ? { width: 79, height: 52.4 }
    : { width: 138, height: 92 }

  if (isBlueProduct) {
    return (
      <BlueProductFlag
        hideFlagOnMobile={false}
        flagWidth={flagSize.width}
        flagHeight={flagSize.height}
        className="absolute top-0 left-0"
        style="flag"
      />
    )
  }

  return (
    <div
      className={`h-[19px] ${
        isExperimentalVitrine
          ? 'sm:h-[21px] text-[9.347px leading-[14px]'
          : 'sm:h-[30px]'
      } flex gap-[4px] px-[6px] items-center font-inter leading-[100%] sm:leading-[150%] ${
        isBalckFriday ? 'font-normal' : 'font-medium'
      } w-fit ${className}`}
      style={{
        backgroundColor: clubFlag ? '#3643BA' : flag?.color,
        color: clubFlag ? '#fff' : flag?.textColor,
      }}
    >
      {flag?.icon && (
        <img
          className="!w-[6px] sm:!w-[12px] h-auto"
          src={flag.icon}
          alt="Flag icon"
        />
      )}
      {flag?.value ?? ''}
    </div>
  )
}

export default ProductFlag
